module.exports = __webpack_public_path__ + "media/images/icons/paper-plane-665399f8984802a292004335c36e9ff9.svg";